import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.css']
})
export class AboutPageComponent {

  isGerman: boolean = true

  setGerman() {
    this.isGerman = true
  }
  setEspanol() {
    this.isGerman = false
  }

}
